import script from "./DraggableCallScript.vue?vue&type=script&setup=true&lang=ts"
export * from "./DraggableCallScript.vue?vue&type=script&setup=true&lang=ts"

import "./DraggableCallScript.vue?vue&type=style&index=0&id=5f808c0d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f808c0d"]])

export default __exports__